module.exports = __webpack_public_path__ + "img/sz.f3bc6cd2.svg";